import { useEffect } from "react";
import "./Modal.css"

interface ModalProps {
    title: string;
    content: JSX.Element;
    isOpen: boolean; 
    onClose: () => void;
    hasCloseBtn?: boolean;
}

export default function Modal({title, content, isOpen, onClose, hasCloseBtn}: ModalProps) {
    hasCloseBtn = hasCloseBtn ?? true;

    // Close modal when 'Escape' is pressed
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown); // Cleanup
        };
    }, [isOpen, onClose]);
  
    if (!isOpen) return null;

    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="d-flex justify-content-space-between">
            <h2 className="capitalize">{title}</h2>
            { hasCloseBtn && <button className="close-modal-button" onClick={onClose}>❌</button> }
          </div>
          {content}
        </div>
      </div>
    );
};

